module.exports = __webpack_public_path__ + "static/media/co.23692df1.webp";